import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-drops',
  templateUrl: './message-drops.component.html',
  styleUrls: ['./message-drops.component.scss']
})
export class MessageDropsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
